const initialState = [];
//
export default function cm0002(state = initialState, action) {
  switch (action.type) {
    case 'SET_CM0002':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CM0002_ERROR':
      return state;
    default:
      return state;
  }
}
